import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

const CLASS_HIDDEN = 'd-none';

export default class extends BridgeComponent {
  static component = 'notification-status';
  static targets = [
    'status',
    'checkingIcon',
    'successIcon',
    'warningIcon',
    'help',
  ];

  connect() {
    super.connect();
    this.send('get-status', {}, this.#handleStatusReply);
  }

  openSettings() {
    this.send('open-settings');
  }

  #handleStatusReply = (message) => {
    if (!message?.data?.status) return;

    const status = message.data.status;
    const enabled = status === 'authorized' || status === 'provisional';

    // Update status text
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = enabled
        ? this.element.dataset.labelEnabled
        : this.element.dataset.labelDisabled;
    }

    // Update icon styling
    [
      this.checkingIconTarget,
      this.successIconTarget,
      this.warningIconTarget,
    ].forEach((icon) => icon.classList.add(CLASS_HIDDEN));

    const iconToShow = enabled
      ? this.successIconTarget
      : this.warningIconTarget;
    iconToShow.classList.remove(CLASS_HIDDEN);

    // Show help text when disabled
    if (this.hasHelpTarget) {
      this.helpTarget.classList.toggle('d-none', enabled);
    }
  };
}
